// extracted by mini-css-extract-plugin
module.exports = {"container":"Filter_container__24JUD","heading":"Filter_heading__h0KyM","pricingHead":"Filter_pricingHead__Xf58U"};